// src/data/countryData.js
export const countryData = {
     "south-africa": {
    countryName: "South Africa",
    code: "ZA",
    flag: "🇿🇦",
    slug: "south-africa",
    cities: ["Johannesburg", "Cape Town", "Durban", "Pretoria"],
    sectors: ["Fintech", "Healthtech", "Renewable Energy", "Logistics"],
    vcFirms: ["Knife Capital", "4Di Capital", "Kalon Venture Partners"],
    govAgencies: ["IDC", "NEF", "SEFA", "TIA"],
    investors: [
      { 
        id: 1, 
        name: "Sipho Dlamini", 
        location: "Johannesburg", 
        industry: "Fintech & SaaS", 
        type: "Angel Investor",
        profileSlug: "/investors/south-africa/sipho-dlamini",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 2, 
        name: "Thandi Mokoena", 
        location: "Cape Town", 
        industry: "Healthtech & Renewable Energy", 
        type: "Venture Partner",
        profileSlug: "/investors/south-africa/thandi-mokoena",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in South Africa?", 
        a: "Discover active angel investors via InvestorLanes, regional angel networks like Jozi Angels, or by targeting local tech startup hubs across Johannesburg and Cape Town." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth South African fintech startups?", 
        a: "Fintech startups in South Africa attract major institutional seed funding and series checks from local venture capital firms like Knife Capital and Kalon Venture Partners." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in South Africa?", 
        a: "In 2026, venture capital funding heavily targets embedded fintech platforms, digital healthtech systems, decentralized renewable energy innovations, and automated business logistics software." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel investors typically request between 10% and 25% equity, depending on your startup's traction benchmarks, current valuation, and the total seed funding capital provided." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in South African tech startups?", 
        a: "Yes, foreign venture capital firms and international angel networks actively invest in South African startups, prioritizing businesses built to scale across the SADC block." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from the initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should founders prepare for due diligence?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product software roadmaps, and verifiable corporate registration documents." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely matches early-stage founders with verified local and international investors, helping startups pitch directly to active venture capital firms and angel networks." 
      }
    ]
  },
    "algeria": {
    countryName: "Algeria",
    code: "DZ",
    flag: "🇩🇿",
    slug: "algeria",
    cities: ["Algiers", "Oran", "Constantine", "Annaba"],
    sectors: ["Fintech", "Industrial Logistics SaaS", "E-commerce Infrastructure", "Agritech Marketplace"],
    vcFirms: ["Algeria Venture", "Casbah Capital", "Numidia Private Equity"],
    govAgencies: ["MND", "ALGERIA-VENTURE", "ANDI", "CNRC"],
    investors: [
      { 
        id: 35, 
        name: "Malik Benhabiles", 
        location: "Algiers", 
        industry: "B2B E-commerce & FinTech Rails", 
        type: "Angel Investor",
        profileSlug: "/investors/algeria/malik-benhabiles",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 36, 
        name: "Amel Ait-Kaci", 
        location: "Oran", 
        industry: "Industrial Logistics SaaS & Smart Supply Chains", 
        type: "Venture Partner",
        profileSlug: "/investors/algeria/amel-ait-kaci",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Algeria?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates, or by targeting local technology hubs and state-backed accelerator facilities operating across Algiers." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Algerian fintech startups?", 
        a: "Fintech infrastructure startups in Algeria secure early backing and seed funding from prominent regional venture capital firms and institutional networks under the Algeria Venture framework." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Algeria?", 
        a: "In 2026, venture capital allocations strongly favor digital transaction processing layers, industrial shipping logistics software, cross-border wholesale marketplaces, and automated agriculture tools." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in North Africa?", 
        a: "Angel syndicates generally request a 10% to 25% equity allotment, calibrated closely to your software's processing transaction metrics, MRR pace, and seed funding goals." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Algerian tech setups?", 
        a: "Yes, international venture funds aggressively deploy capital into Algeria, frequently leveraging modernized structural startup tags and top-level offshore holding frames to clear tranches safely." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Algerian startups?", 
        a: "The standard fundraising velocity spans 3 to 6 months from initial corporate pitch data room presentation to structural due diligence closure and bank wire deployment." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Algerian founders prepare?", 
        a: "Founders require a high-conversion pitch presentation deck, verified financial projection layouts, a clean capitalization model, CNRC incorporation papers, and IP assignment notes." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the Algiers commercial hub?", 
        a: "Pre-seed funding represents early exploratory risk capital raised to transition a software prototype into a functioning MVP, secure early users, and map transactional validation benchmarks." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Algerian operations?", 
        a: "Seed funding is the growth investment layer engineered to aggressively scale user acquisition across North Africa, deploy secondary market infrastructure, and recruit technical engineering operators." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes assist Algerian founders in raising capital?", 
        a: "InvestorLanes bridges the capital access gap by matching high-traction Algerian operators with verified regional venture capital firms and international angel networks cleanly." 
      }
    ]
  },
   "burundi": {
    countryName: "Burundi",
    code: "BI",
    flag: "🇧🇮",
    slug: "burundi",
    cities: ["Bujumbura", "Gitega", "Ngozi", "Rumonge"],
    sectors: ["Fintech", "Agritech & Coffee Logistics", "Trade Enablement Software", "CleanTech Infrastructure"],
    vcFirms: ["Bujumbura Technology Venture", "Zambezi Growth Partners", "East African Frontier Pools"],
    govAgencies: ["API", "BRB", "SETIC", "OBR"],
    investors: [
      { 
        id: 37, 
        name: "Dieudonné Nkurunziza", 
        location: "Bujumbura", 
        industry: "Fintech Remittances & Open API Networks", 
        type: "Angel Investor",
        profileSlug: "/investors/burundi/dieudonne-nkurunziza",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 38, 
        name: "Clara Ndayisaba", 
        location: "Gitega", 
        industry: "Agritech Cooperative SaaS & Trade Platforms", 
        type: "Venture Partner",
        profileSlug: "/investors/burundi/clara-ndayisaba",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Burundi?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates, or by targeting local startup acceleration hubs and cross-border trade networks operating across Bujumbura." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Burundian fintech startups?", 
        a: "Fintech startups in Burundi attract major institutional seed funding and series checks from regional venture networks, ecosystem studios, and cross-border East African venture capital firms." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Burundi?", 
        a: "In 2026, venture capital funding heavily targets cross-border tea and coffee cooperative logistics platforms, horizontal merchant procurement tools, and decentralized off-grid mini-grids." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel investors typically request between 10% and 25% equity, depending on your startup's traction benchmarks, current valuation, and the total seed funding capital provided." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Burundian tech startups?", 
        a: "Yes, international venture funds and foreign angel networks actively invest in Burundian startups, prioritizing setups with robust offshore assignment modules built for regional EAC integration." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from the initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should founders prepare for due diligence?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product software roadmaps, and verifiable OBR corporate tax logs." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely matches early-stage founders with verified local and international investors, helping startups pitch directly to active venture capital firms and angel networks." 
      }
    ]
  },
    "rwanda": {
    countryName: "Rwanda",
    code: "RW",
    flag: "🇷🇼",
    slug: "rwanda",
    cities: ["Kigali", "Gisenyi", "Butare", "Musanze"],
    sectors: ["Fintech", "Healthtech", "Agritech & Smart Supply Chain", "Mobility SaaS"],
    vcFirms: ["Angaza Capital", "Kigali Innovation Fund", "Norrsken22"],
    govAgencies: ["RDB", "MINICT", "RISA", "NIRDA"],
    investors: [
      { 
        id: 15, 
        name: "Jean-Paul Nsanzimana", 
        location: "Kigali", 
        industry: "Fintech & Smart Supply Chain", 
        type: "Angel Investor",
        profileSlug: "/investors/rwanda/jean-paul-nsanzimana",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 16, 
        name: "Divine Mutoni", 
        location: "Gisenyi", 
        industry: "Healthtech & Medical Data APIs", 
        type: "Venture Partner",
        profileSlug: "/investors/rwanda/divine-mutoni",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Rwanda?", 
        a: "Discover active angel allocators via InvestorLanes, regional syndicates like the Kigali Angel Network, or by plugging directly into innovation communities like Norrsken House Kigali." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Rwandan fintech startups?", 
        a: "Fintech infrastructure startups in Rwanda secure heavy early backing and seed funding from prominent regional venture capital firms like Angaza Capital and specialized East African syndicates." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Rwanda?", 
        a: "In 2026, venture capital allocations strongly favor cashless payment integrations, electronic healthcare records software, decentralized drone logistics networks, and climate-smart agritech hubs." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in East Africa?", 
        a: "Angel syndicates generally request a 10% to 25% equity allotment, calibrated closely to your software's processing transaction metrics, MRR pace, and seed funding goals." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Rwandan tech setups?", 
        a: "Yes, international venture funds aggressively deploy capital into Rwanda, leveraging the Kigali International Financial Centre (KIFC) regulatory framework to process asset tranches securely." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Rwandan startups?", 
        a: "The standard fundraising velocity spans 3 to 6 months from initial corporate pitch data room presentation to structural due diligence closure and bank wire deployment." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Rwandan founders prepare?", 
        a: "Founders require a high-conversion pitch presentation deck, verified financial projection layouts, a clean capitalization model, RDB incorporation papers, and IP assignment notes." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the Kigali innovation hub?", 
        a: "Pre-seed funding represents early exploratory risk capital raised to transition a software prototype into a functioning MVP, secure early users, and map transactional validation benchmarks." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Rwandan operations?", 
        a: "Seed funding is the growth investment layer engineered to aggressively scale user acquisition across East Africa, deploy secondary market infrastructure, and recruit technical engineering operators." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes assist Rwandan founders in raising capital?", 
        a: "InvestorLanes bridges the capital access gap by matching high-traction Rwandan operators with verified regional venture capital firms and international angel networks cleanly." 
      }
    ]
  },
    "zimbabwe": {
    countryName: "Zimbabwe",
    code: "ZW",
    flag: "🇿🇼",
    slug: "zimbabwe",
    cities: ["Harare", "Bulawayo", "Chitungwiza", "Mutare"],
    sectors: ["Fintech & Remittances", "Agritech SaaS", "CleanTech", "B2B Logistics"],
    vcFirms: ["Simba Venture Partners", "Zim-Impact Capital", "Kudzai Ventures"],
    govAgencies: ["ZIDA", "POTRAZ", "ZIMRA", "SMEDCO"],
    investors: [
      { 
        id: 23, 
        name: "Farai Moyo", 
        location: "Harare", 
        industry: "Fintech Settlement & Multi-Currency APIs", 
        type: "Angel Investor",
        profileSlug: "/investors/zimbabwe/farai-moyo",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 24, 
        name: "Tendai Sithole", 
        location: "Bulawayo", 
        industry: "Agritech Marketplace & Supply Chain SaaS", 
        type: "Venture Partner",
        profileSlug: "/investors/zimbabwe/tendai-sithole",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Zimbabwe?", 
        a: "Discover active angel investors via InvestorLanes, regional angel networks like the Zimbabwe Angel Network, or by targeting local technology innovation syndicates across Harare." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Zimbabwean fintech startups?", 
        a: "Fintech infrastructure startups in Zimbabwe secure early backing and seed funding from prominent regional venture capital firms and specialized cross-border investment syndicates." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Zimbabwe?", 
        a: "In 2026, venture capital allocations strongly favor multi-currency digital payment layers, B2B wholesale marketplace engines, automated shipping logistics software, and climate-smart agritech tools." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel syndicates generally request a 10% to 25% equity allotment, calibrated closely to your software's processing transaction metrics, MRR pace, and seed funding goals." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Zimbabwean tech setups?", 
        a: "Yes, international venture funds aggressively deploy capital into Zimbabwe, leveraging its highly educated technical talent pool and structured ZIDA investment frameworks." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Zimbabwean startups?", 
        a: "The standard fundraising velocity spans 3 to 6 months from initial corporate pitch data room presentation to structural due diligence closure and bank wire deployment." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Zimbabwean founders prepare?", 
        a: "Founders require a high-conversion pitch presentation deck, verified financial projection layouts, a clean capitalization model, ZIDA registration files, and IP assignment notes." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the Harare commercial hub?", 
        a: "Pre-seed funding represents early exploratory risk capital raised to transition a software prototype into a functioning MVP, secure early users, and map transactional validation benchmarks." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Zimbabwean operations?", 
        a: "Seed funding is the growth investment layer engineered to aggressively scale user acquisition across Southern Africa, deploy secondary market infrastructure, and recruit technical engineering operators." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes assist Zimbabwean founders in raising capital?", 
        a: "InvestorLanes bridges the capital access gap by matching high-traction Zimbabwean operators with verified regional venture capital firms and international angel networks cleanly." 
      }
    ]
  },
    "botswana": {
    countryName: "Botswana",
    code: "BW",
    flag: "🇧🇼",
    slug: "botswana",
    cities: ["Gaborone", "Francistown", "Molepolole", "Maun"],
    sectors: ["Fintech & Payments", "Mining Logistics", "CleanTech", "Enterprise Software"],
    vcFirms: ["Gaborone Innovation Fund", "Kalahari Venture Capital", "Delta Alpha Ventures"],
    govAgencies: ["BITC", "BIH", "BURS", "LEA"],
    investors: [
      { 
        id: 27, 
        name: "Lefoko Seretse", 
        location: "Gaborone", 
        industry: "Fintech Remittance & Cross-Border Billing", 
        type: "Angel Investor",
        profileSlug: "/investors/botswana/lefoko-seretse",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 28, 
        name: "Kaelo Molefe", 
        location: "Francistown", 
        industry: "Mining Logistics SaaS & Supply Chain Automations", 
        type: "Venture Partner",
        profileSlug: "/investors/botswana/kaelo-molefe",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Botswana?", 
        a: "Discover active angel allocators via InvestorLanes, regional syndicates, or by targeting local technology spaces operating across the Botswana Innovation Hub (BIH) in Gaborone." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Botswana fintech startups?", 
        a: "Fintech infrastructure startups in Botswana secure early backing and seed funding from prominent regional venture capital firms and cross-border Southern African asset syndicates." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Botswana?", 
        a: "In 2026, venture capital allocations strongly favor multi-currency corporate billing software, diamond and commodity transport tracking SaaS, decentralized solar mini-grids, and digital business compliance portals." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in Southern Africa?", 
        a: "Angel networks typically target a 10% to 25% equity range, closely balanced against your technical unit economics, user traction curves, and pre-seed scale." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Botswana technology setups?", 
        a: "Yes, international venture funds aggressively deploy capital into Botswana, leveraging its transparent regulatory environment and BITC institutional investor incentives to process asset tranches securely." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Botswana startups?", 
        a: "The complete transaction track typically consumes 3 to 6 months from initial presentation down through automated bookkeeping analysis, risk audits, and dollar wire disbursement." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Botswana founders assemble?", 
        a: "Founders must package an immaculate corporate presentation deck, a solid 5-year accounting projection layout, complete cap tables, and legal company registration files." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation within the local tech hub?", 
        a: "Pre-seed funding represents initial capital deployed to move an idea into a tested software MVP, run pilot customer verification tracks, and anchor the corporate setup." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Botswana operations?", 
        a: "Seed funding is the institutional milestone layer used to push customer expansion past Gaborone corridors, build multi-currency software additions, and hire elite technical talent." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help Botswana founders connect with active capital?", 
        a: "InvestorLanes functions as an optimization highway matching verified Botswana startups directly to active venture capital firms and institutional angel networks." 
      }
    ]
  },
      "senegal": {
    countryName: "Senegal",
    code: "SN",
    flag: "🇸🇳",
    slug: "senegal",
    cities: ["Dakar", "Thies", "Saint-Louis", "Ziguinchor"],
    sectors: ["Fintech & Payments", "B2B E-commerce", "Mobility Software", "Logistics SaaS"],
    vcFirms: ["Wuri Ventures", "Teranga Capital", "Orange Digital Ventures"],
    govAgencies: ["DER/FJ", "APIX", "ADIE", "OPTIC"],
    investors: [
      { 
        id: 21, 
        name: "Moustapha Diop", 
        location: "Dakar", 
        industry: "Fintech Settlement & Mobile Money Hubs", 
        type: "Angel Investor",
        profileSlug: "/investors/senegal/moustapha-diop",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 22, 
        name: "Fatou Ndiaye", 
        location: "Thies", 
        industry: "B2B Retail Marketplace & Logistics Software", 
        type: "Venture Partner",
        profileSlug: "/investors/senegal/fatou-ndiaye",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Senegal?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates like the Dakar Network Angels (DNA), or through innovation-focused public accelerators like DER/FJ." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Senegalese fintech startups?", 
        a: "Fintech startups in Senegal attract major institutional seed funding and series checks from prominent Francophone-focused managers like Wuri Ventures and Teranga Capital." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Senegal?", 
        a: "In 2026, venture capital funding heavily targets embedded financial applications, cross-border merchant processing APIs, local retail distribution marketplaces, and transit route optimization suites." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel investors typically request between 10% and 25% equity, depending on your startup's traction benchmarks, current valuation, and the total seed funding capital provided." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Senegalese tech startups?", 
        a: "Yes, international angel networks and foreign venture capital firms actively allocate capital to Senegalese startups, targeting stable operational environments inside the stable XOF currency block." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from the initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should founders prepare for due diligence?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product software roadmaps, and verifiable APIX registration files." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely matches early-stage founders with verified local and international investors, helping startups pitch directly to active venture capital firms and angel networks." 
      }
    ]
  },
     "libya": {
    countryName: "Libya",
    code: "LY",
    flag: "🇱🇾",
    slug: "libya",
    cities: ["Tripoli", "Benghazi", "Misrata", "Bayda"],
    sectors: ["Fintech Primitives", "Energy Logistics SaaS", "Distribution Tech", "CleanTech Infrastructure"],
    vcFirms: ["Tripoli Tech Seed", "North African Frontier Capital", "Sovereign Asset Syndicates"],
    govAgencies: ["LIA", "CBL", "LY-ICT", "Ministry of Economy"],
    investors: [
      { 
        id: 33, 
        name: "Ahmed Al-Maghribi", 
        location: "Tripoli", 
        industry: "Fintech Merchant Billing & Payment Layer Gateways", 
        type: "Angel Investor",
        profileSlug: "/investors/libya/ahmed-al-maghribi",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 34, 
        name: "Fatima Al-Senussi", 
        location: "Benghazi", 
        industry: "Energy Logistics Software & Automated Asset Routing", 
        type: "Venture Partner",
        profileSlug: "/investors/libya/fatima-al-senussi",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Libya?", 
        a: "Locate active angel allocators through InvestorLanes, regional high-net-worth operator syndicates, or by plugging into emerging frontier tech networks across Tripoli." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Libyan fintech startups?", 
        a: "Fintech and alternative transaction startups secure early scale tracks and seed funding via prominent regional angel syndicates and specialized North African venture capital funds." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Libya?", 
        a: "In 2026, venture capital deployment focuses deeply on automated multi-currency merchant billing, energy supply chain logistics software, digitized distribution networks, and decentralized solar infrastructure." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in North Africa?", 
        a: "Angel networks typically target a 10% to 25% equity range, closely balanced against your technical unit economics, user traction curves, and pre-seed scale." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Libyan technology setups?", 
        a: "Yes, international venture funds aggressively deploy capital into Libyan startups, requiring robust offshore corporate architectures (such as a Delaware or BVI flip) to complete allocations cleanly." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Libyan startups?", 
        a: "The complete transaction track typically consumes 3 to 6 months from initial presentation down through automated bookkeeping analysis, risk audits, and bank wire disbursement." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Libyan founders assemble?", 
        a: "Founders must package an immaculate corporate presentation deck, a solid 5-year accounting projection layout, complete cap tables, and legal company structure documents." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation within the local tech hub?", 
        a: "Pre-seed funding represents initial capital deployed to move an idea into a tested software MVP, run pilot customer verification tracks, and anchor the corporate setup." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Libyan operations?", 
        a: "Seed funding is the institutional milestone layer used to push customer expansion past Tripoli corridors, build multi-currency software additions, and hire elite technical talent." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help Libyan founders connect with active capital?", 
        a: "InvestorLanes functions as an optimization highway matching verified Libyan startups directly to active venture capital firms and institutional angel networks." 
      }
    ]
  },
    "mozambique": {
    countryName: "Mozambique",
    code: "MZ",
    flag: "🇲🇿",
    slug: "mozambique",
    cities: ["Maputo", "Beira", "Nampula", "Matola"],
    sectors: ["Fintech & Mobile Wallets", "Logistics Tech", "Agritech Software", "CleanTech"],
    vcFirms: ["Maputo Innovation Fund", "Zambezi Growth Capital", "Kanimambo Ventures"],
    govAgencies: ["APIEX", "MCTESTP", "INCM", "MCT"],
    investors: [
      { 
        id: 29, 
        name: "Celso Nhancale", 
        location: "Maputo", 
        industry: "Fintech Settlement & Interoperable Wallets", 
        type: "Angel Investor",
        profileSlug: "/investors/mozambique/celso-nhancale",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 30, 
        name: "Amélia Mondlane", 
        location: "Beira", 
        industry: "Port Logistics SaaS & Transit Management Systems", 
        type: "Venture Partner",
        profileSlug: "/investors/mozambique/amelia-mondlane",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Mozambique?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates, or by targeting local startup acceleration hubs operating across Maputo." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Mozambican fintech startups?", 
        a: "Fintech startups in Mozambique attract major institutional seed funding and series checks from regional venture networks, ecosystem studios, and cross-border venture capital firms." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Mozambique?", 
        a: "In 2026, venture capital funding heavily targets interoperable digital wallet infrastructure, port logistics optimization tools, decentralized solar smart management platforms, and last-mile retail supply chains." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel investors typically request between 10% and 25% equity, depending on your startup's traction benchmarks, current valuation, and the total seed funding capital provided." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Mozambican tech startups?", 
        a: "Yes, international venture funds and foreign angel networks actively invest in Mozambican startups, prioritizing businesses building cross-border tech links within the SADC block." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from the initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should founders prepare for due diligence?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product software roadmaps, and verifiable APIEX compliance certificates." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely matches early-stage founders with verified local and international investors, helping startups pitch directly to active venture capital firms and angel networks." 
      }
    ]
  },
    "mali": {
    countryName: "Mali",
    code: "ML",
    flag: "🇲🇱",
    slug: "mali",
    cities: ["Bamako", "Sikasso", "Mopti", "Segou"],
    sectors: ["Fintech", "Agritech Supply Chain", "CleanTech SaaS", "Cross-Border Trade"],
    vcFirms: ["Bamako Venture Studio", "Sahel Growth Capital", "West Africa Alternative Assets"],
    govAgencies: ["API-Mali", "AGETIC", "ANPE", "DGI"],
    investors: [
      { 
        id: 31, 
        name: "Ibrahim Keita", 
        location: "Bamako", 
        industry: "Mobile Money & Transactional Fintech", 
        type: "Angel Investor",
        profileSlug: "/investors/mali/ibrahim-keita",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 32, 
        name: "Oumou Toure", 
        location: "Sikasso", 
        industry: "Agritech Sourcing & Inventory Automation", 
        type: "Venture Partner",
        profileSlug: "/investors/mali/oumou-toure",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Mali?", 
        a: "Discover active angel investors via InvestorLanes, localized private operator syndicates, or by tracking tech-focused venture networks operating across the Bamako corridor." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Malian fintech startups?", 
        a: "Fintech startups in Mali attract institutional seed funding and early growth checks from regional alternative asset managers and West African venture studios." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Mali?", 
        a: "In 2026, venture capital allocations strongly favor transaction-level fintech primitives, digitized agricultural supply-chain platforms, automated cross-border trade solutions, and off-grid solar networks." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in West Africa?", 
        a: "Angel syndicates generally request a 10% to 25% equity allotment, calibrated closely to your software's processing transaction metrics, MRR pace, and seed funding goals." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Malian tech setups?", 
        a: "Yes, international venture capital firms actively deploy capital into Mali, looking for teams with solid unit economics and an offshore parent holding framework to secure asset deals." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Malian startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Malian founders prepare?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product roadmaps, and corporate registration documents from API-Mali." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely connects early-stage founders with verified local and international investors, helping startups pitch directly to active capital allocators." 
      }
    ]
  },
       "morocco": {
    countryName: "Morocco",
    code: "MA",
    flag: "🇲🇦",
    slug: "morocco",
    cities: ["Casablanca", "Rabat", "Marrakesh", "Tangier"],
    sectors: ["Fintech", "B2B E-commerce", "Logistics Tech", "Edtech"],
    vcFirms: ["Outlierz Ventures", "Maroc Numeric Fund", "Azur Innovation Fund"],
    govAgencies: ["AMDIE", "ADD", "CCG", "OMPIC"],
    investors: [
      { 
        id: 11, 
        name: "Youssef Benjelloun", 
        location: "Casablanca", 
        industry: "B2B E-commerce & FinTech", 
        type: "Angel Investor",
        profileSlug: "/investors/morocco/youssef-benjelloun",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 12, 
        name: "Meriam El Fassi", 
        location: "Rabat", 
        industry: "Logistics SaaS & Edtech Platforms", 
        type: "Venture Partner",
        profileSlug: "/investors/morocco/meriam-el-fassi",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Morocco?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates like Angels 4 Africa, or by targeting local technology hubs and innovation hubs operating across Casablanca." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Moroccan fintech startups?", 
        a: "Fintech infrastructure startups in Morocco secure early backing and seed funding from prominent regional venture capital firms like Outlierz Ventures and Maroc Numeric Fund." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Morocco?", 
        a: "In 2026, venture capital allocations strongly favor digital transaction processing layers, B2B wholesale marketplace engines, automated shipping logistics software, and multi-currency cloud-based edtech tools." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in North Africa?", 
        a: "Angel syndicates generally request a 10% to 25% equity allotment, calibrated closely to your software's processing transaction metrics, MRR pace, and seed funding goals." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Moroccan tech setups?", 
        a: "Yes, international venture funds aggressively deploy capital into Morocco, leveraging its deep strategic integration with European trade systems and stable legal frameworks." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Moroccan startups?", 
        a: "The standard fundraising velocity spans 3 to 6 months from initial corporate pitch data room presentation to structural due diligence closure and bank wire deployment." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Moroccan founders prepare?", 
        a: "Founders require a high-conversion pitch presentation deck, verified financial projection layouts, a clean capitalization model, OMPIC incorporation papers, and IP assignment notes." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the Casablanca commercial hub?", 
        a: "Pre-seed funding represents early exploratory risk capital raised to transition a software prototype into a functioning MVP, secure early users, and map transactional validation benchmarks." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Moroccan operations?", 
        a: "Seed funding is the growth investment layer engineered to aggressively scale user acquisition across North Africa, deploy secondary market infrastructure, and recruit technical engineering operators." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes assist Moroccan founders in raising capital?", 
        a: "InvestorLanes bridges the capital access gap by matching high-traction Moroccan operators with verified regional venture capital firms and international angel networks cleanly." 
      }
    ]
  },
      "angola": {
    countryName: "Angola",
    code: "AO",
    flag: "🇦🇴",
    slug: "angola",
    cities: ["Luanda", "Benguela", "Huambo", "Lobito"],
    sectors: ["Fintech & Payments", "B2B Marketplace", "Logistics Software", "Mobility Tech"],
    vcFirms: ["Bantu Makers", "Angola Venture Capital", "Fundo de Capital de Risco"],
    govAgencies: ["INAPEM", "AIPEX", "MINTIC", "BNA"],
    investors: [
      { 
        id: 13, 
        name: "Manuel Fonseca", 
        location: "Luanda", 
        industry: "Fintech Settlement & Remittances", 
        type: "Angel Investor",
        profileSlug: "/investors/angola/manuel-fonseca",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 14, 
        name: "Ana Santos", 
        location: "Benguela", 
        industry: "B2B Logistics & Mobility Software", 
        type: "Venture Partner",
        profileSlug: "/investors/angola/ana-santos",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Angola?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates, or by targeting local startup acceleration hubs operating across Luanda." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Angolan fintech startups?", 
        a: "Fintech startups in Angola attract major institutional seed funding and series checks from local venture networks, ecosystem studios like Bantu Makers, and regional venture teams." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Angola?", 
        a: "In 2026, venture capital funding heavily targets interoperable digital wallet infrastructure, merchant digital billing engines, automated transport logistics SaaS, and last-mile retail supply chains." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel investors typically request between 10% and 25% equity, depending on your startup's traction benchmarks, current valuation, and the total seed funding capital provided." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Angolan tech startups?", 
        a: "Yes, international venture funds and foreign angel networks actively invest in Angolan startups, prioritizing businesses building cross-border tech links within the SADC block." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from the initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should founders prepare for due diligence?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product software roadmaps, and verifiable AIPEX compliance certificates." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely matches early-stage founders with verified local and international investors, helping startups pitch directly to active venture capital firms and angel networks." 
      }
    ]
  },
      "namibia": {
    countryName: "Namibia",
    code: "NA",
    flag: "🇳🇦",
    slug: "namibia",
    cities: ["Windhoek", "Walvis Bay", "Swakopmund", "Oshakati"],
    sectors: ["Fintech & Banking APIs", "Logistics Tech", "CleanTech", "Agritech"],
    vcFirms: ["Windhoek Innovation Fund", "Namibia Venture Capital", "Desert Alpha Fund"],
    govAgencies: ["NIPDB", "NCRST", "Bonn", "NamRA"],
    investors: [
      { 
        id: 25, 
        name: "Johannes Ndlovu", 
        location: "Windhoek", 
        industry: "Fintech Billing & CMA Integration Rails", 
        type: "Angel Investor",
        profileSlug: "/investors/namibia/johannes-ndlovu",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 26, 
        name: "Helena Amupolo", 
        location: "Walvis Bay", 
        industry: "Logistics SaaS & Port Automation Software", 
        type: "Venture Partner",
        profileSlug: "/investors/namibia/helena-amupolo",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Namibia?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates, or by targeting local startup acceleration hubs operating across Windhoek." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Namibian fintech startups?", 
        a: "Fintech startups in Namibia attract major institutional seed funding and series checks from local venture networks, ecosystem studios, and regional cross-border venture capital firms." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Namibia?", 
        a: "In 2026, venture capital funding heavily targets interoperable digital wallet infrastructure, port logistics optimization tools, decentralized solar smart management platforms, and last-mile retail supply chains." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel investors typically request between 10% and 25% equity, depending on your startup's traction benchmarks, current valuation, and the total seed funding capital provided." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Namibian tech startups?", 
        a: "Yes, international venture funds and foreign angel networks actively invest in Namibian startups, prioritizing businesses building cross-border tech links within the CMA and SADC blocks." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from the initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should founders prepare for due diligence?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product software roadmaps, and verifiable NIPDB compliance certificates." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely matches early-stage founders with verified local and international investors, helping startups pitch directly to active venture capital firms and angel networks." 
      }
    ]
  },
      "tanzania": {
    countryName: "Tanzania",
    code: "TZ",
    flag: "🇹🇿",
    slug: "tanzania",
    cities: ["Dar es Salaam", "Arusha", "Mwanza", "Dodoma"],
    sectors: ["Fintech & Mobile Money", "Agritech Distribution", "Logistics Tech", "CleanTech"],
    vcFirms: ["Dar es Salaam Innovation Fund", "Saba Growth Capital", "East Africa Venture Fund"],
    govAgencies: ["TIC", "COSTECH", "BRELA", "TCRA"],
    investors: [
      { 
        id: 19, 
        name: "Abasi Mussa", 
        location: "Dar es Salaam", 
        industry: "Fintech Remittance & Agent Banking APIs", 
        type: "Angel Investor",
        profileSlug: "/investors/tanzania/abasi-mussa",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 20, 
        name: "Neema Shayo", 
        location: "Arusha", 
        industry: "Agritech Marketplace & Supply Chain SaaS", 
        type: "Venture Partner",
        profileSlug: "/investors/tanzania/neema-shayo",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Tanzania?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates like the Tanzania Angel Investors Network, or by targeting local technology hubs operating across Dar es Salaam." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Tanzanian fintech startups?", 
        a: "Fintech infrastructure startups in Tanzania secure early backing and seed funding from prominent regional venture capital firms and specialized East African investment syndicates." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Tanzania?", 
        a: "In 2026, venture capital allocations strongly favor interoperable mobile payment layers, digitized B2B agricultural marketplaces, automated freight transport logistics software, and off-grid renewable energy mini-grids." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in East Africa?", 
        a: "Angel syndicates generally request a 10% to 25% equity allotment, calibrated closely to your software's processing transaction metrics, MRR pace, and seed funding goals." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Tanzanian tech setups?", 
        a: "Yes, international venture funds aggressively deploy capital into Tanzania, leveraging stable regional EAC trade corridors and modernized data protection frameworks to process asset tranches securely." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Tanzanian startups?", 
        a: "The standard fundraising velocity spans 3 to 6 months from initial corporate pitch data room presentation to structural due diligence closure and bank wire deployment." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Tanzanian founders prepare?", 
        a: "Founders require a high-conversion pitch presentation deck, verified financial projection layouts, a clean capitalization model, BRELA incorporation papers, and IP assignment notes." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the Dar es Salaam tech corridor?", 
        a: "Pre-seed funding represents early exploratory risk capital raised to transition a software prototype into a functioning MVP, secure early users, and map transactional validation benchmarks." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Tanzanian operations?", 
        a: "Seed funding is the growth investment layer engineered to aggressively scale user acquisition across East Africa, deploy secondary market infrastructure, and recruit technical engineering operators." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes assist Tanzanian founders in raising capital?", 
        a: "InvestorLanes bridges the capital access gap by matching high-traction Tanzanian operators with verified regional venture capital firms and international angel networks cleanly." 
      }
    ]
  },
     "zambia": {
    countryName: "Zambia",
    code: "ZM",
    flag: "🇿🇲",
    slug: "zambia",
    cities: ["Lusaka", "Kitwe", "Ndola", "Livingstone"],
    sectors: ["Fintech & Banking APIs", "Mining Logistics SaaS", "Agritech Marketplace", "CleanTech Infrastructure"],
    vcFirms: ["Kukula Capital", "Lusaka Venture Partners", "Zambezi Growth Fund"],
    govAgencies: ["ZDA", "NTBC", "ZRA", "BOZ"],
    investors: [
      { 
        id: 41, 
        name: "Chileshe Mwamba", 
        location: "Lusaka", 
        industry: "Fintech Settlement & Interoperable Merchant Accounts", 
        type: "Angel Investor",
        profileSlug: "/investors/zambia/chileshe-mwamba",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 42, 
        name: "Mwansa Banda", 
        location: "Kitwe", 
        industry: "Mining Logistics SaaS & Supply Chain Optimization Software", 
        type: "Venture Partner",
        profileSlug: "/investors/zambia/mwansa-banda",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Zambia?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates, or by targeting local startup acceleration hubs operating across Windhoek." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Zambian fintech startups?", 
        a: "Fintech startups in Zambia attract major institutional seed funding and series checks from local venture networks, ecosystem studios, and regional cross-border venture capital firms." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Zambia?", 
        a: "In 2026, venture capital funding heavily targets interoperable digital wallet infrastructure, port logistics optimization tools, decentralized solar smart management platforms, and last-mile retail supply chains." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel investors typically request between 10% and 25% equity, depending on your startup's traction benchmarks, current valuation, and the total seed funding capital provided." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Zambian tech startups?", 
        a: "Yes, international venture funds and foreign angel networks actively invest in Zambian startups, prioritizing businesses building cross-border tech links within the SADC blocks." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from the initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should founders prepare for due diligence?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product software roadmaps, and verifiable ZDA compliance certificates." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely matches early-stage founders with verified local and international investors, helping startups pitch directly to active venture capital firms and angel networks." 
      }
    ]
  },
       "drc": {
    countryName: "Democratic Republic of Congo",
    code: "CD",
    flag: "🇨🇩",
    slug: "drc",
    cities: ["Kinshasa", "Lubumbashi", "Goma", "Kisangani"],
    sectors: ["Fintech", "Mining Supply Chain SaaS", "B2B Logistics Software", "CleanTech Infrastructure"],
    vcFirms: ["Kinshasa Venture Studio", "Congo Growth Capital", "Central Africa Private Equity"],
    govAgencies: ["ANAPI", "ARPTC", "DGI", "OCC"],
    investors: [
      { 
        id: 43, 
        name: "Dieudonné Kabamba", 
        location: "Kinshasa", 
        industry: "Fintech Settlement & Multi-Currency APIs", 
        type: "Angel Investor",
        profileSlug: "/investors/drc/dieudonne-kabamba",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 44, 
        name: "Clara Mutamba", 
        location: "Lubumbashi", 
        industry: "Mining Logistics SaaS & Resource Tracking Tools", 
        type: "Venture Partner",
        profileSlug: "/investors/drc/clara-mutamba",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in the DRC?", 
        a: "Discover active angel allocators via InvestorLanes, regional syndicates, or by targeting local technology innovation hubs operating across major Kinshasa centers." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Congolese fintech startups?", 
        a: "Fintech infrastructure startups in the DRC secure heavy early backing and seed funding from prominent regional venture capital firms and specialized Central African investment syndicates." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in the DRC?", 
        a: "In 2026, venture capital allocations strongly favor dollarized payment settlement layers, enterprise resource tracking software for minerals, B2B wholesale marketplace networks, and clean off-grid hydro or solar infrastructure grids." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in Central Africa?", 
        a: "Angel syndicates generally request a 10% to 25% equity allotment, calibrated closely to your software's processing transaction metrics, MRR pace, and seed funding goals." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Congolese tech setups?", 
        a: "Yes, international venture funds aggressively deploy capital into the DRC, frequently requiring a Delaware or Mauritius top-level flip structure to process cross-border asset deals safely." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Congolese startups?", 
        a: "The standard fundraising velocity spans 3 to 6 months from initial corporate pitch data room presentation to structural due diligence closure and bank wire deployment." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Congolese founders prepare?", 
        a: "Founders require a high-conversion pitch presentation deck, verified financial projection layouts, a clean capitalization model, ANAPI incorporation papers, and IP assignment notes." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the Kinshasa tech corridor?", 
        a: "Pre-seed funding represents early exploratory risk capital raised to transition a software prototype into a functioning MVP, secure early users, and map transactional validation benchmarks." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Congolese operations?", 
        a: "Seed funding is the growth investment layer engineered to aggressively scale user acquisition across Central and Francophone Africa, deploy secondary market infrastructure, and recruit technical engineering operators." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes assist Congolese founders in raising capital?", 
        a: "InvestorLanes bridges the capital access gap by matching high-traction Congolese operators with verified regional venture capital firms and international angel networks cleanly." 
      }
    ]
  },
      "ghana": {
    countryName: "Ghana",
    code: "GH",
    flag: "🇬🇭",
    slug: "ghana",
    cities: ["Accra", "Kumasi", "Tamale", "Takoradi"],
    sectors: ["Fintech & Remittances", "Agritech Marketplace", "Healthtech", "Logistics Software"],
    vcFirms: ["MEST Africa", "Changer Capital", "Oasis Capital"],
    govAgencies: ["NEIP", "GIPC", "GEA", "NITA"],
    investors: [
      { 
        id: 9, 
        name: "Kwame Mensah", 
        location: "Accra", 
        industry: "Fintech Remittance Rails", 
        type: "Angel Investor",
        profileSlug: "/investors/ghana/kwame-mensah",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 10, 
        name: "Efua Baah", 
        location: "Kumasi", 
        industry: "Agritech Inventory Software", 
        type: "Venture Partner",
        profileSlug: "/investors/ghana/efua-baah",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Ghana?", 
        a: "Discover active angel investors via InvestorLanes, regional networks like the Accra Angels Network, or through localized tech ecosystem incubators like MEST Africa." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Ghanaian fintech startups?", 
        a: "Fintech startups in Ghana attract major institutional seed funding and series checks from local and regional venture capital firms like Oasis Capital and specialized West African syndicates." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Ghana?", 
        a: "In 2026, venture capital funding heavily targets cross-border remittance platforms, digitized agricultural marketplace apps, alternative health tracking models, and logistics optimization suites." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel investors typically request between 10% and 25% equity, depending on your startup's traction benchmarks, current valuation, and the total seed funding capital provided." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Ghanaian tech startups?", 
        a: "Yes, international angel networks and foreign venture capital firms actively allocate capital to Ghanaian startups, targeting stable operational environments inside the ECOWAS zone." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from the initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should founders prepare for due diligence?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product software roadmaps, and verifiable GIPC registration files." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely matches early-stage founders with verified local and international investors, helping startups pitch directly to active venture capital firms and angel networks." 
      }
    ]
  },
     "nigeria": {
    countryName: "Nigeria",
    code: "NG",
    flag: "🇳🇬",
    slug: "nigeria",
    cities: ["Lagos", "Abuja", "Ibadan", "Port Harcourt"],
    sectors: ["Fintech", "E-commerce", "Healthtech", "Logistics SaaS"],
    vcFirms: ["Ventures Platform", "Future Africa", "Ingressive Capital"],
    govAgencies: ["NITDA", "BOI", "SMEDAN", "NEPC"],
    investors: [
      { 
        id: 3, 
        name: "Olumide Akanbi", 
        location: "Lagos", 
        industry: "Fintech & Open Banking", 
        type: "Angel Investor",
        profileSlug: "/investors/nigeria/olumide-akanbi",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 4, 
        name: "Chidi Egwu", 
        location: "Abuja", 
        industry: "Logistics & Agritech SaaS", 
        type: "Venture Partner",
        profileSlug: "/investors/nigeria/chidi-egwu",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Nigeria?", 
        a: "Discover active angel investors via InvestorLanes, regional syndicates like the Lagos Angel Network (LAN), or by engaging with early-stage founder networks across Yaba." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Nigerian fintech startups?", 
        a: "Fintech infrastructure startups in Nigeria secure heavy early backing and seed funding from prominent regional venture capital firms like Ventures Platform and Future Africa." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Nigeria?", 
        a: "In 2026, institutional venture capital dollars strongly favor embedded fintech payment rails, cross-border digital merchant e-commerce engines, healthcare data APIs, and logistics software frameworks." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in Nigeria?", 
        a: "Angel syndicates generally request a 10% to 25% equity allotment, calibrated closely to your software's processing transaction metrics, MRR pace, and seed funding goals." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Nigerian tech setups?", 
        a: "Yes, international venture funds aggressively deploy capital into Nigerian tech hubs, frequently mandating a Delaware top-level flip structure to process cross-border asset deals safely." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Nigerian startups?", 
        a: "The standard fundraising velocity spans 3 to 6 months from initial corporate pitch data room presentation to structural due diligence closure and bank wire deployment." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Nigerian founders prepare?", 
        a: "Founders require a high-conversion pitch presentation deck, verified audited accounting tables, a clean capitalization layout model, CAC registration files, and intellectual property assignment notes." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the Nigerian tech hub?", 
        a: "Pre-seed funding represents early exploratory risk capital raised to transition a software prototype into a functioning MVP, secure early users, and map transactional validation benchmarks." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Nigerian operations?", 
        a: "Seed funding is the growth investment layer engineered to aggressively scale user acquisition across West Africa, deploy secondary market infrastructure, and recruit technical engineering operators." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes assist Nigerian founders in raising capital?", 
        a: "InvestorLanes bridges the capital access gap by matching high-traction Nigerian operators with verified regional venture capital firms and international angel networks cleanly." 
      }
    ]
  },
       "lesotho": {
    countryName: "Lesotho",
    code: "LS",
    flag: "🇱🇸",
    slug: "lesotho",
    cities: ["Maseru", "Teyateyaneng", "Mafeteng", "Hlotse"],
    sectors: ["Fintech", "Textile Supply Chain", "CleanTech Infrastructure", "Logistics Software"],
    vcFirms: ["Maseru Venture Studio", "Alpine Asset Management", "Maluti Capital Partners"],
    govAgencies: ["LNDC", "BEDCO", "CBL", "LRA"],
    investors: [
      { 
        id: 39, 
        name: "Thabo Letsie", 
        location: "Maseru", 
        industry: "CMA Fintech & Interoperable Mobile Wallets", 
        type: "Angel Investor",
        profileSlug: "/investors/lesotho/thabo-letsie",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 40, 
        name: "Mpho Mokoena", 
        location: "Maseru", 
        industry: "Textile Inventory SaaS & Export Logistics Software", 
        type: "Venture Partner",
        profileSlug: "/investors/lesotho/mpho-mokoena",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Lesotho?", 
        a: "Discover active angel investors via InvestorLanes, cross-border operator syndicates, or by targeting local technology spaces operating across Maseru hubs." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Basotho fintech startups?", 
        a: "Fintech startups in Lesotho attract institutional seed funding and early growth checks from cross-border venture capital firms integrated within the Common Monetary Area (CMA)." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Lesotho?", 
        a: "In 2026, venture capital allocations strongly favor multi-currency corporate billing gateways, commercial textile supply chain automation software, and decentralized solar mini-grids." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in Southern Africa?", 
        a: "Angel networks typically target a 10% to 25% equity range, closely balanced against your technical unit economics, user traction curves, and pre-seed scale." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Basotho technology setups?", 
        a: "Yes, international venture funds aggressively deploy capital into Lesotho, leveraging its transparent regulatory environment and close integration into the South African economic corridor." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Lesotho startups?", 
        a: "The complete transaction track typically consumes 3 to 6 months from initial presentation down through automated bookkeeping analysis, risk audits, and bank wire disbursement." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Lesotho founders assemble?", 
        a: "Founders must package an immaculate corporate presentation deck, a solid 5-year accounting projection layout, complete cap tables, and legal company registration files." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation within the local tech hub?", 
        a: "Pre-seed funding represents initial capital deployed to move an idea into a tested software MVP, run pilot customer verification tracks, and anchor the corporate setup." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Basotho operations?", 
        a: "Seed funding is the institutional milestone layer used to push customer expansion past Maseru corridors, build multi-currency software additions, and hire elite technical talent." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help Lesotho founders connect with active capital?", 
        a: "InvestorLanes functions as an optimization highway matching verified Lesotho startups directly to active venture capital firms and institutional angel networks." 
      }
    ]
  },
    "uganda": {
    countryName: "Uganda",
    code: "UG",
    flag: "🇺🇬",
    slug: "uganda",
    cities: ["Kampala", "Entebbe", "Jinja", "Mbarara"],
    sectors: ["Fintech & Payments", "Agritech Distribution", "CleanTech", "Logistics Software"],
    vcFirms: ["Kampala Innovation Fund", "Yvke Capital", "Pearl Capital Partners"],
    govAgencies: ["NITA-U", "UIA", "UNCST", "URSB"],
    investors: [
      { 
        id: 17, 
        name: "Brian Mukasa", 
        location: "Kampala", 
        industry: "Fintech Settlement & Last-Mile Delivery", 
        type: "Angel Investor",
        profileSlug: "/investors/uganda/brian-mukasa",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 18, 
        name: "Fiona Namubiru", 
        location: "Entebbe", 
        industry: "Agritech Marketplace & Inventory Software", 
        type: "Venture Partner",
        profileSlug: "/investors/uganda/fiona-namubiru",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Uganda?", 
        a: "Discover active angel investors via InvestorLanes, regional networks like the Kampala Angel Investment Network (KAIN), or through localized tech ecosystem incubators." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Ugandan fintech startups?", 
        a: "Fintech startups in Uganda attract major institutional seed funding and series checks from local and regional venture capital firms like Pearl Capital Partners and specialized East African syndicates." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Uganda?", 
        a: "In 2026, venture capital funding heavily targets interoperable mobile payment platforms, digitized agricultural distribution networks, smart off-grid solar grids, and B2B freight tracking applications." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request during seed stages?", 
        a: "Angel investors typically request between 10% and 25% equity, depending on your startup's traction benchmarks, current valuation, and the total seed funding capital provided." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Ugandan tech startups?", 
        a: "Yes, international angel networks and foreign venture capital firms actively allocate capital to Ugandan startups, targeting steady operational environments inside the East African Community." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "The typical startup fundraising cycle takes between 3 to 6 months from the initial pitch presentation deck down to legal due diligence and final capital disbursement wires." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should founders prepare for due diligence?", 
        a: "Founders must prepare an immaculate pitch presentation deck, a 3-to-5-year financial projection model, a clean cap table format, product software roadmaps, and verifiable URSB incorporation documents." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed funding represents the earliest risk capital raised to validate an early business idea, assemble a basic functional MVP setup, and conduct initial transactional market research." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding is capital used to scale an established software MVP, fund early market user acquisition channels, and grow the core technical team after showing product-market fit." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely matches early-stage founders with verified local and international investors, helping startups pitch directly to active venture capital firms and angel networks." 
      }
    ]
  },
    "kenya": {
    countryName: "Kenya",
    code: "KE",
    flag: "🇰🇪",
    slug: "kenya",
    cities: ["Nairobi", "Mombasa", "Kisumu", "Nakuru"],
    sectors: ["Fintech & Mobile Money", "Agritech", "CleanTech", "Logistics Software"],
    vcFirms: ["Savannah Fund", "HEVA Fund", "Novastar Ventures"],
    govAgencies: ["Konza Technopolis", "KenInvest", "MSEA", "ICT Authority"],
    investors: [
      { 
        id: 5, 
        name: "Mwangi Kamau", 
        location: "Nairobi", 
        industry: "Mobile Money & CleanTech", 
        type: "Angel Investor",
        profileSlug: "/investors/kenya/mwangi-kamau",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 6, 
        name: "Amina Osei", 
        location: "Mombasa", 
        industry: "Agritech Supply Chain", 
        type: "Venture Partner",
        profileSlug: "/investors/kenya/amina-osei",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Kenya?", 
        a: "Locate active angel allocators through InvestorLanes, regional syndicates like the Nairobi Angel Network (NAN), or by plugging into innovation accelerators across the Silicon Savannah." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Kenyan fintech and mobile money startups?", 
        a: "Fintech and mobile money startups secure early scale tracks and seed funding via prominent alternative investment teams like Savannah Fund and Novastar Ventures." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Kenya?", 
        a: "In 2026, venture capital deployment focuses deeply on automated mobile-money API loops, tech-enabled agriculture marketplaces, clean off-grid solar tech networks, and smart logistics frameworks." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel networks usually request in East Africa?", 
        a: "Angel networks typically target a 10% to 25% equity range, closely balanced against your technical unit economics, user traction curves, and pre-seed scale." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign allocators invest in Kenyan technology setups?", 
        a: "Yes, international asset managers heavily target Kenya, leveraging its mature tech regulations and infrastructure to channel funds smoothly into East and Central Africa." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for Kenyan startups?", 
        a: "The complete transaction track typically consumes 3 to 6 months from initial presentation down through automated bookkeeping analysis, risk audits, and dollar wire disbursement." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Kenyan founders assemble?", 
        a: "Founders must package an immaculate corporate presentation deck, a solid 5-year accounting projection layout, complete cap tables, and legal company registration files." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation within the Silicon Savannah?", 
        a: "Pre-seed funding represents initial capital deployed to move an idea into a tested software MVP, run pilot customer verification tracks, and anchor the corporate setup." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for Kenyan operations?", 
        a: "Seed funding is the institutional milestone layer used to push customer expansion past Nairobi corridors, build multi-currency software additions, and hire elite technical talent." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help Kenyan founders connect with active capital?", 
        a: "InvestorLanes functions as an optimization highway matching verified Kenyan startups directly to active venture capital firms and institutional angel networks." 
      }
    ]
  },

    "egypt": {
    countryName: "Egypt",
    code: "EG",
    flag: "🇪🇬",
    slug: "egypt",
    cities: ["Cairo", "Alexandria", "Giza", "Mansoura"],
    sectors: ["Fintech", "Logistics", "E-commerce", "Proptech"],
    vcFirms: ["Flat6Labs", "Sawari Ventures", "Algebra Ventures"],
    govAgencies: ["ITIDA", "TIEC", "MSMEDA", "GAFI"],
    investors: [
      { 
        id: 7, 
        name: "Tarek Mansour", 
        location: "Cairo", 
        industry: "Embedded Finance & SaaS", 
        type: "Angel Investor",
        profileSlug: "/investors/egypt/tarek-mansour",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      },
      { 
        id: 8, 
        name: "Yasmine Khalil", 
        location: "Alexandria", 
        industry: "Proptech & Marketplace Platforms", 
        type: "Venture Partner",
        profileSlug: "/investors/egypt/yasmine-khalil",
        photoURL: "/default-avatar.png", 
        lastSeen: "Active 2026" 
      }
    ],
    extendedFAQs: [
      { 
        tag: "angel networks",
        q: "How do I find active angel investors in Egypt?", 
        a: "Discover active angel investors and angel networks via InvestorLanes, or target prominent local groups like the Cairo Angels network to secure your early allocation." 
      },
      { 
        tag: "fintech firms",
        q: "Who invests in high-growth Egyptian fintech startups?", 
        a: "Egyptian fintech models receive institutional seed funding and series checks from leading regional venture capital firms including Algebra Ventures and Flat6Labs accelerators." 
      },
      { 
        tag: "venture capital",
        q: "What industries attract venture capital funding in Egypt?", 
        a: "In 2026, Cairo's venture market heavily values scalable B2B e-commerce, digital mass logistics software, embedded consumer fintech apps, and real estate proptech frameworks." 
      },
      { 
        tag: "equity parameters",
        q: "How much equity do angel investors usually request during seed rounds?", 
        a: "Angels operating across Egypt typically trade seed capital for a 10% to 25% equity block, scaled tightly against your startup's product traction benchmarks and current revenue lines." 
      },
      { 
        tag: "foreign capital",
        q: "Can foreign investors allocate capital to Egyptian startups?", 
        a: "Yes, Egypt's strategic geography bridges MENA and Africa, drawing significant venture attention from Gulf capital allocators and international venture capital firms looking for cross-border expansion." 
      },
      { 
        tag: "long does",
        q: "How long does the fundraising cycle take for local startups?", 
        a: "Anticipate a timeline of 3 to 6 months from initial presentation to complete regulatory clearance, structure offshore corporate holding frameworks, and clear final capital disbursement paths." 
      },
      { 
        tag: "documents",
        q: "What legal corporate documents should Egyptian founders prepare for due diligence?", 
        a: "Assemble an absolute pitch summary deck, multi-year operating financial spreadsheets, GAFI corporate structural registration papers, and a transparent capitalization cap table layout." 
      },
      { 
        tag: "pre-seed",
        q: "What is pre-seed funding validation inside the local ecosystem?", 
        a: "Pre-seed resources allow builders to test core digital hypotheses, assemble initial application interfaces, validate unit economics, and secure foundational user data." 
      },
      { 
        tag: "seed funding",
        q: "What is seed funding scale capital for regional expansion?", 
        a: "Seed funding injections allow Egyptian startups to aggressively expand user acquisition across North Africa, fund core engineering tiers, and cross regional market boundaries." 
      },
      { 
        tag: "platform value",
        q: "How does InvestorLanes help founders connect with active capital pools?", 
        a: "InvestorLanes securely links local North African innovators to an expanded global network of verified venture capital firms and professional angel networks." 
      }
    ]
  }
};
